module.exports = __webpack_public_path__ + "assets/images/project/bannerimage/bannerimage.jpg?v=fcb32dbb";